export default __webpack_public_path__ + "static/media/right.b2e50e03.png";